import { render, staticRenderFns } from "./ReadDialog_4_2.vue?vue&type=template&id=35dd700a&"
import script from "./ReadDialog_4_2.vue?vue&type=script&lang=js&"
export * from "./ReadDialog_4_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports